// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","937":"78e521c3"}[chunkId] || chunkId) + "-" + {"230":"428f24a86b7d99af44f5","256":"b62f0be23c0039e39f03","731":"8876de813cd1ddb4afa5","843":"76084f09ff646c3df143","937":"637fb5b6c25ea845f6a2"}[chunkId] + ".js";
};